export default {
  COUPONS20_PAGE: 'COUPONS20_PAGE',
  COUPONS20_PER_COUPON_GROUPING: 'COUPONS20_PER_COUPON_GROUPING',
  COUPONS20_FOP_ON_OFFERS_PAGE: 'COUPONS20_FOP_ON_OFFERS_PAGE',
  COUPONS20_LINK_ON_FOP: 'COUPONS20_LINK_ON_FOP',
};
